module.exports = __WEBPACK_EXTERNAL_MODULE_N27b__;